import { Clickable, Col, LanguageSelector, Row, Text } from 'components';
import { theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Auth, Loading } from './components';

const BallImage = styled.div`
  position: absolute;
  height: 450px;
  width: 420px;
  top: -225px;
  left: 270px;
  z-index: 1;
  background-image: url(${(props) => props.image});
  background-repeat: round;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Ball = styled.div`
  width: 136px;
  height: 136px;
  border-radius: 136px;
  background-repeat: round;
  background-color: ${theme.SECONDARY};
  z-index: 2;
`;

const BallImageMobile = styled.div`
  position: absolute;
  top: 30px;
  width: 121px;
  height: 121px;
  background-image: url(${(props) => props.image});
  background-repeat: round;
  z-index: 1;
`;

const Phone = styled.div`
  ${(props) => `
  position: absolute;
  height: ${props.ht};
  width: ${props.wid};
  background-repeat: round;
  background-image: url(${props.image});
  z-index: ${props.zIndex};
  top: ${props.top};
  left: ${props.left};
`}
`;

const Login = ({ isSidebar }) => {
  const [loading, setLoading] = useState(false),
    user = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    navigate = useNavigate(),
    dispatch = useDispatch();

  useEffect(() => {
    if (user && !isSidebar) navigate('/home');
  }, []);

  function goToAboutUs() {
    navigate('/', { state: { fromAuth: true } });
  }

  function handleLoading() {
    setLoading(!loading);
  }

  if (loading) return <Loading />;

  if (isMobile)
    return (
      <Col wid="100%" centerAll ht="100%" bg={theme.GREY_10} start>
        <BallImageMobile image={require('assets/branding/logo-icon-grey-20.png')} />

        <Col marg="90px 0 0" wid="100vw" bg="#fff" zIndex={2}>
          <Auth handleLoading={handleLoading} />

          <Col noFlex wid="100%" centerAll>
            <Clickable onClick={goToAboutUs}>
              <Text>{t('common.aboutUs')}</Text>
            </Clickable>
          </Col>
        </Col>
      </Col>
    );

  return (
    <Col
      noFlex
      pos="absolute"
      wid="100vw"
      ht="100vh"
      centerAll
      start
      style={{ overflowY: 'scroll' }}
    >
      <Row wid={isMobile ? '100wv' : '1440px'} ht="100vh" start pos="relative">
        {!isMobile && (
          <React.Fragment>
            <BallImage image={require('assets/branding/logo-icon-grey-20.png')}>
              <Ball />
            </BallImage>

            <Phone
              image={require('assets/branding/phone-1.png')}
              wid="272px"
              ht="546px"
              zIndex={2}
              top="108px"
              left="436px"
            />

            <Phone
              image={require('assets/branding/phone-2.png')}
              wid="240px"
              ht="484px"
              zIndex={1}
              top="138px"
              left="252px"
            />

            <Col pos="absolute" left="254px" bottom="70px">
              <LanguageSelector />

              <Clickable onClick={goToAboutUs}>
                <Text>{t('common.aboutUs')}</Text>
              </Clickable>
            </Col>
          </React.Fragment>
        )}

        <Auth handleLoading={handleLoading} />
      </Row>
    </Col>
  );
};

export default Login;
